// FIRST, before anything that creates the Supabase client: closing every
// OnHand tab signs you out (18 September 2026). See src/lib/tabSession.js.
import './lib/tabSession';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
